export default "__VITE_ASSET__a8219df3__"